import React from 'react';
import { useAllergyPickerMode } from '../../data/domains/config';
import AllergiesDislikesScreen from '../../customer/AllergiesDislikesScreen';
import AllergiesDislikesScreenV3 from '../../customer/AllergiesDislikesScreenV3';

/** Routes split (v1) vs combined (v3) allergy picker via `app_config.allergy_picker_mode`. */
export default function ResolvedAllergiesDislikesScreen() {
  const allergy_picker_mode = useAllergyPickerMode();
  if (allergy_picker_mode === 'combined') {
    return <AllergiesDislikesScreenV3 />;
  }
  return <AllergiesDislikesScreen />;
}
